import {defineCustomElement} from 'extensions/utils';
import GenesisModal from './lib/GenesisModal';

export {
	GenesisModal
};

defineCustomElement('g-modal', GenesisModal);
